import { MessageDescriptor, PrimitiveType } from 'react-intl';

export type MessageDescriptorWithValues = MessageDescriptor & {
    values?: Record<string, PrimitiveType>;
};

export function isMessageDescriptor(value: unknown): value is MessageDescriptor {
    return (
        typeof value === 'object' && value !== null && ('id' in value || 'defaultMessage' in value)
    );
}

export function isMessageDescriptorWithValues(
    value: unknown,
): value is MessageDescriptorWithValues {
    return isMessageDescriptor(value) && 'values' in value && value.values !== undefined;
}
